import { useEffect } from 'react';
import { HubConnectionState } from '@microsoft/signalr';
import { queryClient, queryKeys } from '@/api/query-client';
import { createConversationHubConnection } from '@/lib/signalr';

/**
 * Ouvre la connexion SignalR au hub des conversations pendant le montage de la page, et
 * invalide la requête `conversation` à chaque `MessagePosted` reçu du serveur.
 *
 * On invalide plutôt qu'on ne fusionne le message reçu directement dans le cache : le
 * volume d'une conversation support est faible, et l'invalidation évite de dupliquer côté
 * client la logique de dédoublonnage/tri déjà faite par le backend.
 */
export function useConversationRealtime() {
  useEffect(() => {
    const connection = createConversationHubConnection();

    connection.on('MessagePosted', () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.conversation });
    });

    connection.start().catch(() => {
      // Échec de connexion temps réel : la conversation reste consultable, juste sans mise
      // à jour instantanée. Pas de remontée d'erreur bloquante pour un confort dégradé.
    });

    return () => {
      if (connection.state !== HubConnectionState.Disconnected) {
        void connection.stop();
      }
    };
  }, []);
}
